import tinymce from 'tinymce/tinymce'
import 'tinymce/models/dom'
import 'tinymce/icons/default'
import 'tinymce/plugins/link'
import 'tinymce/plugins/autoresize'
import 'tinymce/plugins/image'
import 'tinymce/plugins/pagebreak'
import 'tinymce/plugins/lists'
import 'tinymce/themes/silver'
import 'tinymce-i18n/langs6/de'

var tinymceOptions = {
  selector: '.tinymce',
  skin: false,
  content_css: false,
  branding: false,
  language: 'de',
  height: 500,
  plugins: 'link, autoresize, pagebreak, image, lists',
  toolbar: 'numlist bullist',
  pagebreak_separator: '<div class="alwaysbreak"></div>',
  a11y_advanced_options: true,
  relative_urls : false,
  remove_script_host: false,
  convert_urls: false,
  promotion: false
}

document.addEventListener('initialize', function() {
  tinymce.remove()
  tinymce.init(tinymceOptions)
})
